(function(angular){
	'use strict';
	
	angular.module('reAverageDividendYieldChartModule', [
		'BaseConfig',
		'highChartsModule'
	]);
	
})(window.angular);